import React from "react";
import './list.css'

const ListCard = (props) => {
  const { imgUrl, title, url  } = props.item;

  return (
    <div className="single__course__item">
      <div className="course__img">
        <img src={imgUrl} alt="" className="w-100" />
      </div>

      <div className="course__details">
        <a className="course__title mb-4" href={url}>{title}</a>
          <p className="enroll d-flex align-items-center gap-1">
          </p>
        </div>
      </div>
   
  );
};

export default ListCard;